;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .filter('timeFilter', function ($filter) {
      return function (date) {
        const newDate = moment(date)
        return newDate.format('HH:mm')
      }
    })
})()
